<template>
  <div class="page">
    <div class="main">
      <van-loading v-if="loading" class="loading" size="24px" vertical>加载中...</van-loading>

      <div class="records" v-if="!loading">
        <div class="record" v-for="(record, index) in records" :key="record.id">
          <div class="record-header flex-box">
            <div class="type">订单类型：{{convertRecordType(record.level)}}</div>
            <div class="date">付款日期：{{record.date}}</div>
          </div>
          <div class="record-title">{{convertRecordTitle(record.level, record.issue)}}</div>
          <div class="price-and-usage flex-box">
            <div class="price">付款金额：¥{{record.price}}</div>
            <div class="usage-and-remain flex-box">
              <div class="remain" v-if="record.level == 'membership'">{{getRemainHint(record.level, index)}}</div>
              <div class="usage">{{getUsageHint(record.level, index)}}</div>
            </div>
          </div>
        </div>
        <div class="no-more">"没有更多了～"</div>
      </div>

    </div>
  </div>
</template>

<script>
// import wx from 'weixin-js-sdk'
import { Toast, Dialog, Loading} from 'vant'

export default{
  components: {
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Loading.name]: Loading
  },
  data(){
    return {
      openid: '',
      records: [],
      loading: true
    }
  },
  methods: {
    getPaymentRecord(){
      let openid = this.$store.state.userinfo.openid
      this.$api.get('/couple/get_payment_record', {openid: openid}, res => {
        if(res.code == 200){
          this.loading = false
          this.records = res.records
        }
      })
    },
    convertRecordType(level){
      if(level == "basic"){
        return "标准入场模式"
      }else if(level == "prior"){
        return "优先入场模式"
      }else if(level == "membership"){
        return "超级入场模式"
      }
    },
    convertRecordTitle(level, issue){
      if(level == "basic"){
        return `【浪漫员】3天CP第${issue}期-标准入场`
      }else if(level == "prior"){
        return `【浪漫员】3天CP第${issue}期-优先入场`
      }else if(level == "membership"){
        return `【浪漫员】3天CP-超级入场（累计3期）`
      }
    },
    getUsageHint(level, index){
      if(level == "basic"){
        return "已使用"
      }else if(level == "prior"){
        return "已使用"
      }else if(level == "membership"){
        let remain = this.records[index].remain
        let usage = 3 - remain
        return `已使用${usage}期`
      }
    },
    getRemainHint(level, index){
      if(level == "basic"){
        return "剩余0期"
      }else if(level == "prior"){
        return "剩余0期"
      }else if(level == "membership"){
        let remain = this.records[index].remain
        return `剩余${remain}期`
      }
    }
  },
  mounted(){
    this.getPaymentRecord()
  }
}
</script>

<style scoped>
.page{
  min-height:100vh;
  background-color: #f8f8f8;
  padding:20px;
  width: 100%;
  height: 100%;
}
.loading{margin-top:30%;}
.records{font-size:22px;color:#8d8b8b;}
.records .record{
  width: 100%;
  background: #fff;
  margin-top: 30px;
  box-shadow: 0 5px 8px 0 rgb(51 51 51 / 5%);
  border-radius: 15px;
  padding:20px;
  border:1px solid #eb8e80;
}
.records .record .record-header{justify-content:space-between;border-bottom:1px solid #d2d6de;padding-bottom:20px;}
.records .record .record-title{font-size:28px;color:#333;font-weight:bold;text-align:left;margin-top:30px;margin-bottom:30px;}
.records .record .price-and-usage{justify-content:space-between;}
.records .record .usage{border:1px solid #8d8b8b;border-radius:5px;padding:2px 10px;margin-left:20px;}
.records .record .remain{border:1px solid #eb8e80;border-radius:5px;padding:2px 10px;color:#eb8e80;}
.records .no-more{font-size:22px;color:#8590a6;text-align:center;margin-top:20px;}
</style>
